let webAppInstance = null

export function getWebApp() {
  if (webAppInstance) return webAppInstance
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    webAppInstance = window.Telegram.WebApp
  }
  return webAppInstance || {
    initData: '',
    initDataUnsafe: {},
    platform: 'unknown',
    ready: () => {},
    expand: () => {},
    close: () => {},
    showAlert: (message) => window.alert(message),
  }
}

export function telegramAuthHeaders(tg = getWebApp()) {
  return { 'X-Telegram-Init-Data': tg.initData || '' }
}

export function isTelegramWebApp() {
  if (typeof window === 'undefined') return false

  const tg = window.Telegram?.WebApp
  if (!tg) return false

  const platform = String(tg.platform || '').trim().toLowerCase()
  const initData = String(tg.initData || '').trim()

  if (!initData) return false
  if (!platform || platform === 'unknown') return false

  return true
}

export function initTelegramWebApp() {
  const tg = getWebApp()
  tg.ready()
  tg.expand()
  if (typeof tg.requestFullscreen === 'function') {
    tg.requestFullscreen()
  }
  return tg
}
